import colorSharp from "../assets/images/color-sharp.png";

const papers = [
  {
    title: "Exploring Design Attributes and Development of an Acoustic VR Game to Improve Ethical Values of Visually Impaired People",
    venue: "IEEE",
    venueColor: "#00aaff",
    description: "This research develops an acoustic virtual reality game for visually impaired individuals to enhance their ethical values and situational awareness. The evaluation study shows moderate effectiveness and efficiency, with a high recommendation rate of 87% among participants.",
    link: "https://ieeexplore.ieee.org/abstract/document/9824116",
    tags: ["HCI", "Accessibility", "VR"],
  },
  {
    title: "Evaluating Usability of Mobile Financial Applications Used in Bangladesh",
    venue: "Springer",
    venueColor: "#ff6b35",
    description: "This research evaluates the usability of popular mobile banking applications in Bangladesh to address digital illiteracy among mobile phone users. Four common usability issues were identified, and findings were used to create design requirements for improvement.",
    link: "https://link.springer.com/chapter/10.1007/978-3-031-20364-0_15",
    tags: ["Usability", "HCI", "Mobile"],
  },
  {
    title: "CareMother: An Innovative Assistive System for Expecting Women",
    venue: "Springer",
    venueColor: "#ff6b35",
    description: "A mobile IoT application developed to assist expectant mothers in monitoring essential health parameters such as blood pressure, heart rate, temperature, sleep cycle, and location — ensuring safety for both mother and unborn child. Published as a journal article — first author.",
    link: "https://link.springer.com/article/10.1007/s44250-025-00199-6",
    tags: ["IoT", "Mobile", "Healthcare"],
  },
  {
    title: "A Blockchain-Based Framework to Develop a Sustainable Supply Chain Management System for the Apparel Industry",
    venue: "IEEE",
    venueColor: "#00aaff",
    description: "To overcome constraints identified in the current supply chain management system through literature elicitation and surveys, a blockchain-based framework is proposed for developing a sustainable supply chain management system for the textile industry.",
    link: "https://ieeexplore.ieee.org/abstract/document/10456466",
    tags: ["Blockchain", "Supply Chain", "Sustainability"],
  },
];

export const Research = () => {
  return (
    <section className="research" id="research">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="research-bx">
              <span className="research-label">Academic Work</span>
              <h2>Research</h2>
              <p className="research-desc">
                My research sits at the intersection of HCI, accessibility, and software engineering.
                I care about building technology that works for everyone — especially those who are often overlooked.
              </p>
              <div className="research-cards">
                {papers.map((paper, i) => (
                  <div className="research-card" key={i}>
                    <div className="research-card-header">
                      <span
                        className="research-venue"
                        style={{ color: paper.venueColor, borderColor: paper.venueColor }}
                      >
                        {paper.venue}
                      </span>
                      <div className="research-tags">
                        {paper.tags.map((tag, j) => (
                          <span className="research-tag" key={j}>{tag}</span>
                        ))}
                      </div>
                    </div>
                    <h4 className="research-title">
                      {paper.link ? (
                        <a href={paper.link} target="_blank" rel="noreferrer">{paper.title}</a>
                      ) : (
                        paper.title
                      )}
                    </h4>
                    <p className="research-abstract">{paper.description}</p>
                    {paper.link && (
                      <a
                        href={paper.link}
                        target="_blank"
                        rel="noreferrer"
                        className="research-link-btn"
                      >
                        Read Paper →
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};
